import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
export const Image = ({ image, smallImage }) => {
    return (_jsxs(Picture, { children: [smallImage && _jsx("source", { media: "(max-width: 768px)", srcSet: smallImage }), _jsx(Img, { src: image })] }));
};
const Picture = styled.picture `
  display: inline-flex;
  align-items: center;
`;
const Img = styled.img ``;
